'use strict';

require('../modules/forms/forms');

angular.module('far.forms.pageForm', ['dekky.forms'])
    .service('pageForm', function(form, Page, fileUploadFilters, showModalMessage) {
        var pageForm = form('page');

        pageForm
            .addField('parent', 'selectObject', {
                validators: {
                    required: true
                },
                ngOptions: 'item as item.name disable when item.disable for item in field.items track by item.id',
                label: 'Родительская страница'
            }, Page.list)
            .addField('name', 'text', {
                validators: {
                    required: true
                },
                options: {
                    placeholder: 'Заголовок'
                },
                label: 'Заголовок'
            })
            .addField('url', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Url'
                },
                label: 'Url'
            })
            .addField('menu', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Показывать в меню'
                },
                label: 'Показывать в меню'
            })
            .addField('sortable', 'number', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Позиция в меню'
                },
                label: 'Позиция в меню'
            })
            .addField('menu_name', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Заголовок меню'
                },
                label: 'Заголовок меню'
            })
            .addField('content', 'textarea', {
                validators: {
                    required: false
                },
                options: {
                    redactor: true,
                    placeholder: '...'
                },
                label: 'Содержание'
            })
            .addField('meta_title', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Meta title'
                },
                label: 'Meta title'
            })
            .addField('meta_description', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Meta description'
                },
                label: 'Meta description'
            })
            .addField('meta_keywords', 'text', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Meta keywords'
                },
                label: 'Meta keywords'
            })
            .addField('slides_files', 'imageUpload', {
                validators: { required: true },
                label: 'Загрузить изображение',
                uploader: {
                    url: Routing.generate('api_upload_post_image'),
                    filters: [
                        fileUploadFilters.fileSize()
                    ],
                    autoUpload: true,
                    removeAfterUpload: true,
                    onWhenAddingFileFailed: function(item, filter) {
                        var message = filter.message ? filter.message : 'Невозможно загрузить файл на сервер';

                        showModalMessage(message);
                    }
                }
            }).addField('disable_comments', 'checkbox', {
                validators: {
                    required: false
                },
                options: {
                    placeholder: 'Отключить комментарии'
                },
                label: 'Отключить комментарии'
            })
            ;

        return pageForm;
    });
